import { render, staticRenderFns } from "./Customers.vue?vue&type=template&id=5a5b7b08&scoped=true"
import script from "./Customers.vue?vue&type=script&lang=ts"
export * from "./Customers.vue?vue&type=script&lang=ts"
import style0 from "./Customers.vue?vue&type=style&index=0&id=5a5b7b08&prod&lang=scss&scoped=true"
import style1 from "./Customers.vue?vue&type=style&index=1&id=5a5b7b08&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a5b7b08",
  null
  
)

export default component.exports